import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchData, GET_WEBSITE_CONTENT, UPSERT_HOME_CONTENT, DROPDOWN_DATA, ASSET_ENDPOINT } from "../../components/Service";
import { validateForm, ButtonSpinner, removeMsg, noImageHandle, blobToBase64 } from "../../components/CommonMethod";
import Question from "../Workbook/partials/Question";
import { CKEditor } from 'ckeditor4-react';
import TestimonialList from "./Components/TestimonialList";

const HomePage = () => {
    window.document.title = "Edit Home Page";
    const [tinyloader, setTinyLoader] = useState('')
    const [data, setData] = useState('')
    const [questionTypeList, setQuestionTypeList] = useState([]);
    const [questionData, setQuestionData] = useState([]);
    const [formfield, setFormfield] = useState({
        featured_videob64: "",
        featured_imgb64: "",
    })

    const saveHomeContent = (e) => {
        let questionFormdata = new FormData(document.getElementById(document.getElementById('real=form-id').value))
        let formdata = new FormData(document.getElementById('addHomeContent'))

        for (let [key, value] of questionFormdata.entries()) {
            formdata.append(key, value);
        }
        formdata.append('featured_file_type', formfield.featured_videob64 ? 'video' : 'image');

        if (validateForm(e, "addHomeContent") && validateForm(e, "real=form-id")) {
            setTinyLoader(true);
            fetchData(UPSERT_HOME_CONTENT, 'POST', formdata, true, true, (res) => {
                setTinyLoader(false);
                if (res.success) {
                    removeMsg()
                }
            });
        };
    }

    useEffect(() => {
        fetchData(GET_WEBSITE_CONTENT + '/home-content', 'GET', '', true, false, (res) => {
            if (res.records) {
                res.records && setData(JSON.parse(res.records.value));
                let question = JSON.parse(res.records.value).question;
                setTimeout(() => {
                    if (question) {
                        setQuestionData(JSON.parse(res.records.value))
                    } else {
                        setQuestionData({ question: [] })
                    }
                }, 200);
            }
        });

        fetchData(DROPDOWN_DATA + '?type=question_type', 'GET', '', true, false, (res) => {
            if (res.records) {
                setQuestionTypeList(res.records.question_type)
            }
        })
    }, [])


    const checkVideoSize = async(e) => {
        var video_error = document.querySelectorAll('#video_error')
        var element = document.querySelector('#featured_video')
        var video_size = element.files[0].size
        if (video_size / 1024 > 5120) {
            video_error.forEach((ele) => {
                ele.classList.remove('text-muted')
                ele.classList.add('text-danger')
            })
            element.value = ''
        } else {
            video_error.forEach((ele) => {
                ele.classList.add('text-muted')
                ele.classList.remove('text-danger')
            })
            const imgb64 = await blobToBase64(e.target.files[0])
            if(e.target.files[0].type === 'video/mp4'){
                setFormfield({ featured_videob64: imgb64, featured_imgb64: "" })
            }else{
                setFormfield({ featured_imgb64: imgb64, featured_videob64: "" })
            }
        }
    }

    return (
        <>
            <div className="container-fluid">
                <div className="page-head sticky_top_padding">
                    <div className="row">
                        <div className="col-sm-12">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb fw-bold text-uppercase mb-2 fs-14">
                                    <li className="breadcrumb-item"><Link to="/cms/website-content">Website Content</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Home page</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <div className="row gx-4 mb-1 align-items-lg-end align-items-md-end  align-items-center">
                        <div className="col-lg-6 col-sm  col-6 mb-3">
                            <h1 className="h3 text-dim mb-0">Edit ‘Home Page’ content</h1>
                        </div>
                        <div className="col-lg-6 col-auto mb-3 col-6">
                            <button type="button" className="btn btn-theme-primary btn-lg float-end" onClick={saveHomeContent} disabled={tinyloader}>
                                <ButtonSpinner load={tinyloader} btnName="Save" />
                            </button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <form className="needs-validation" noValidate id="addHomeContent">
                        <div className="col-sm-12">
                            <div className="maxw-560 mb-5">
                                <h4 className="fw-bold mb-5">Title caption</h4>
                                <div className="form-floating mt-30 mb-5">
                                    <input type="text" name="title" id="title" className="form-control form-control-md" defaultValue={data && data.title ? data.title : ''} required placeholder="Title" />
                                    <div className="invalid-feedback">Please fill title.</div>
                                    <label>Title <strong className="text-danger">*</strong></label>
                                </div>
                                <div className="form-floating mt-30">
                                    <input type="text" name="sub_title" id="sub_title" className="form-control form-control-md" defaultValue={data && data.sub_title ? data.sub_title : ''} required placeholder="Subtitle" />
                                    <div className="invalid-feedback">Please fill subtitle.</div>
                                    <label>Subtitle <strong className="text-danger">*</strong></label>
                                </div>
                            </div>
                            <div className="col-md-7 col-xxl-6 mt-3">
                            <p className="fw-bold fs-18 text-uppercase mb-2">Feature Image/Video</p>
                            <div className="d-flex flex-column" >
                                <div htmlFor="ReuploadVideo" className="h-260">
                                    {data?.featured_video || formfield.featured_videob64 || formfield.featured_imgb64 ? <>
                                        {(formfield.featured_videob64 || formfield.featured_imgb64) ? <>
                                            {formfield.featured_videob64 ? <video controls className="h-260 w-sm100 rounded-2" src={formfield.featured_videob64} alt="Featured Video" type="video/mp4" /> : <img src={formfield.featured_imgb64} className="maxw-360 img-fluid" alt="Featured Video" onError={noImageHandle} />}
                                        </> : <>
                                            {data?.featured_file_type === 'video' ? <video controls className="h-260 w-sm100 rounded-2" src={ASSET_ENDPOINT + data.featured_video} alt="Featured Video" type="video/mp4" /> : <img src={ASSET_ENDPOINT + data.featured_video} className="maxw-360 img-fluid" alt="Featured Video" onError={noImageHandle} />}
                                        </>}
                                    </> : <img src="/images/about-banner.png" className="maxw-360 img-fluid" alt="Featured Video" onError={noImageHandle} />}
                                </div>
                                <label className="btn btn-theme-primary btn my-3 maxw-200">
                                    <div className="overflow-hidden position-relative">
                                        <input type="file" id="featured_video" name="featured_video" accept=".mp4,.jpg,.png,.jpeg" className="position-absolute opacity-0" onChange={checkVideoSize} />
                                    </div>Upload image/video
                                </label>

                            </div>
                            <small className="text-muted pt-2 fw-bold" id="video_error">Please upload .mp4,.jpg,.png,.jpeg type file with maximum size 5 Mb.</small>
                        </div>
                            <div className="mb-5">
                                <h4 className="fw-bold">Interactive demo question</h4>
                                <div className="card border-secondary rounded-3">
                                    <div className="card-body p-sm-4">
                                        <div className="d-none"><CKEditor initData={''} editorUrl='../ckeditor/ckeditor.js' /></div>
                                        <input type="hidden" name="solution_image" value={data && data.question && data.question.solution_image ? data.question.solution_image : ''} />
                                        {questionData && questionData.question && <Question from_home_page="home_page" title="Drag and drop to fill in the blanks." questionType='drag_and_fill' questionElementId='dummy_question' questionTypeList={questionTypeList} questionData={questionData.question} />}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <TestimonialList page='home' className="p-4" />
            </div>
        </>
    )
}

export default HomePage
